export default __webpack_public_path__ + "static/image1-5b217aa3b42f9e690e49c22a379986ec.jpg";